import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  SearchUpdateLoanFormComponent
} from './modules/reverse-mortgage/search-update-loan-form/search-update-loan-form.component';
import {ReverseMortgageComponent} from './modules/reverse-mortgage/reverse-mortgage.component';
import {HomeComponent} from './modules/home/home.component';
import {HolidayComponent} from './modules/admin/holiday/holiday.component';
import {AdminComponent} from './modules/admin/admin.component';
import {
  PostPurchaseAdjustmentsComponent
} from './modules/admin/post-purchase-adjustments/post-purchase-adjustments.component';
import {ReportsComponent} from './modules/admin/reports/reports.component';
import {OldMonthlyReportsComponent} from './modules/admin/old-monthly-reports/old-monthly-reports.component';
import {
  UpdateSystemAttributesComponent
} from './modules/admin/update-system-attributes/update-system-attributes.component';
import {
  UpdateDeveloperAttributesComponent
} from './modules/admin/update-developer-attributes/update-developer-attributes.component';
import {QueryTransactionsComponent} from './modules/reverse-mortgage/query-transactions/query-transactions.component';
import {QueryLoansComponent} from './modules/reverse-mortgage/query-loans/query-loans.component';
import {QueryLoansResultComponent} from './modules/reverse-mortgage/query-loans-result/query-loans-result.component';
import {QueryLoanDetailsComponent} from './modules/reverse-mortgage/query-loans-details/query-loans-details.component';
import {
  QueryTransactionDetailsComponent
} from './modules/reverse-mortgage/query-transaction-details/query-transaction-details.component';
import {
  SearchUpdateResultComponent
} from './modules/reverse-mortgage/search-update-result/search-update-result.component';
import {
  PostpurchaseupdateComponent
} from './modules/admin/post-purchase-adjustments/postpurchaseupdate/postpurchaseupdate.component';
import {LoanDetailsComponent} from './modules/reverse-mortgage/loan-details/loan-details.component';
import {AuthenticationGuard} from './services/authentication.guard';
import {ViewTransmissionComponent} from './modules/reverse-mortgage/view-transmission/view-transmission.component';
import {
  QueryTransactionsResultsComponent
} from './modules/reverse-mortgage/query-transactions-results/query-transactions-results.component';
import {UploadFileComponent} from './modules/reverse-mortgage/upload-file/upload-file.component';
import {
  QueryServicerTransfersComponent
} from './modules/reverse-mortgage/query-servicer-transfers/query-servicer-transfers.component';
import {
  PerformTransactionsComponent
} from './modules/reverse-mortgage/perform-transactions/perform-transactions.component';
import {
  ServicerTransfersResultsComponent
} from './modules/reverse-mortgage/servicer-transfers-results/servicer-transfers-results.component';
import {
  ServiceTranferApproveDeleteComponent
} from './modules/reverse-mortgage/service-tranfer-approve-delete/service-tranfer-approve-delete.component';
import {
  ServiceTransferPortfolioIndicatorComponent
} from './modules/reverse-mortgage/servicer-transfers-results/service-transfer-portfolio-indicator/service-transfer-portfolio-indicator.component';
import {
  QueryTransactionsDeleteComponent
} from './modules/reverse-mortgage/query-transactions-delete/query-transactions-delete.component';
import {ContactInfoComponent} from './modules/reverse-mortgage/contact-info/contact-info.component';
import {HelpComponent} from './help/help.component';
import {
  SubmitTrialBalanceComponent
} from './modules/reverse-mortgage/submit-trial-balance/submit-trial-balance.component';
import {
  TrialBalanceResultComponent
} from './modules/reverse-mortgage/trial-balance-result/trial-balance-result.component';
import {ErrorPageComponent} from './shared/error-page/error-page.component';
import {PrintViewComponent} from './shared/print-view/print-view.component';
import {AccountingReportsComponent} from './modules/reverse-mortgage/accounting-reports/accounting-reports.component';
import {ReportsCreiteriaComponent} from './shared/reports-creiteria/reports-creiteria.component';
import {
  AccountingViewPurchaseAdviceComponent
} from './modules/reverse-mortgage/accounting-view-purchase-advice/accounting-view-purchase-advice.component';
import {
  DeliveryViewPurchaseAdviceComponent
} from './modules/reverse-mortgage/delivery-view-purchase-advice/delivery-view-purchase-advice.component';
import {Constants} from './constants/ebtq-constants';

const routes: Routes = [
  {
    path: '', redirectTo: 'mainMenu', pathMatch: 'full'
  },
  {
    path: 'reverseMortgage',
    component: ReverseMortgageComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.DELIVERY_VIEW_ROLE, Constants.DELIVERY_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'mainMenu',
    component: HomeComponent, canActivate: [AuthenticationGuard]
  },
  {
    path: 'searchupdateloan',
    component: SearchUpdateLoanFormComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE,
        Constants.DELIVERY_VIEW_ROLE, Constants.DELIVERY_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE],
      accessiblity: 'delivery'
    }
  },
  {
    path: 'viewtransmission',
    component: ViewTransmissionComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'admin',
    component: AdminComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'holiday',
    component: HolidayComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'postPurchaseAdj',
    component: PostPurchaseAdjustmentsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'postPurchaseUpdate',
    component: PostpurchaseupdateComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'error',
    component: ErrorPageComponent, canActivate: [AuthenticationGuard]
  },
  {
    path: 'adminReports',
    component: ReportsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'oldMonthlyReports',
    component: OldMonthlyReportsComponent, canActivate: [AuthenticationGuard]
  },
  {
    path: 'updateSystemAttributes',
    component: UpdateSystemAttributesComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'updateDeveloperAttributes',
    component: UpdateDeveloperAttributesComponent, canActivate: [AuthenticationGuard], data: {
      roles: [ Constants.DEV_ROLE, Constants.DEV_A9_ROLE ]
    }
  },
  {
    path: 'queryTransactions',
    component: QueryTransactionsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE,
        Constants.RMINT_VIEW_A9_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'serviceTransfersResults',
    component: ServicerTransfersResultsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'accountingViewPurchaseAdvice',
    component: AccountingViewPurchaseAdviceComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'deliveryViewPurchaseAdvice',
    component: DeliveryViewPurchaseAdviceComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE,
        Constants.DELIVERY_VIEW_ROLE, Constants.DELIVERY_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE],
      accessiblity: 'delivery'
    }
  },
  {
    path: 'submitTrialBalance',
    component: SubmitTrialBalanceComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'trialBalanceResult',
    component: TrialBalanceResultComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'confirmApprove',
    component: ServiceTranferApproveDeleteComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'confirmDelete',
    component: ServiceTranferApproveDeleteComponent, canActivate: [AuthenticationGuard]
  },
  {
    path: 'partialServiceTransfer',
    component: ServiceTransferPortfolioIndicatorComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'confirmDeleteTrans',
    component: QueryTransactionsDeleteComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE,
        Constants.RMINT_VIEW_A9_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'queryLoans',
    component: QueryLoansComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'queryLoansResult',
    component: QueryLoansResultComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'queryLoansDetails',
    component: QueryLoanDetailsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'queryTransactionDetails',
    component: QueryTransactionDetailsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE,
        Constants.RMINT_VIEW_A9_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE]
    }
  },
  {
    path: 'queryServicerTransfers',
    component: QueryServicerTransfersComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'transactionsResults',
    component: QueryTransactionsResultsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE,
        Constants.RMINT_VIEW_A9_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'searchResult',
    component: SearchUpdateResultComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE,
        Constants.DELIVERY_VIEW_ROLE, Constants.DELIVERY_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE]
    }
  },
  {
    path: 'loanDetails',
    component: LoanDetailsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE,
        Constants.DELIVERY_VIEW_ROLE, Constants.DELIVERY_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE]
    }
  },
  {
    path: 'print',
    component: PrintViewComponent, canActivate: [AuthenticationGuard]
  },
  {
    path: 'uploadFile',
    component: UploadFileComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'transactions',
    component: PerformTransactionsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'contactInfo',
    component: ContactInfoComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.DELIVERY_UPDATE_ROLE],
      accessiblity: 'delivery'
    }
  },
  {
    path: 'help',
    component: HelpComponent, canActivate: [AuthenticationGuard]
  },
  {
    path: 'accountingReports',
    component: AccountingReportsComponent, canActivate: [AuthenticationGuard], data: {
      roles: [Constants.ADMIN_ROLE, Constants.DEV_ROLE, Constants.SERV_UPDATE_ROLE, Constants.SERV_VIEW_ROLE,
        Constants.RMINT_UPDATE_ROLE, Constants.RMINT_UPDATE_A9_ROLE, Constants.RMINT_VIEW_ROLE, Constants.RMINT_VIEW_A9_ROLE,
        Constants.ADMIN_A9_ROLE, Constants.DEV_A9_ROLE],
      accessiblity: 'servicing'
    }
  },
  {
    path: 'reportCreiteria',
    component: ReportsCreiteriaComponent, canActivate: [AuthenticationGuard]
  },
  {
    path: 'monthlyReportCreiteria',
    component: ReportsCreiteriaComponent, canActivate: [AuthenticationGuard]
  }

];

@NgModule({
  // onSameUrlNavigation prevents features such as a "refresh" button.
  // Now while clicking same page from left menu It will refresh
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation : 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
